//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";
import tabs from "angular-ui-bootstrap/src/tabs";
import uiRouter from "angular-ui-router";

//modules

//services
// replace: \.(component|directive)\("(\w+)",\s*(\w+)\) with: $2,

//components
import syncDataFileContainer from "servicestack/data-files/data-file-container";

//directives
// import parcelPicker from "servicestack/data-files/parcel-picker/parcel-picker.directive";

//states
import dataFileStates, {
  getStates,
} from "servicestack/data-files/data-file.states";

export const dependencies = [dropdown, collapse, tabs, uiRouter];

export const modules = {};

//const deps = ["emun.auth", "webutils", "webforms", "webmodals", "ui.router"];

export const services = {};

export const components = {
  syncDataFileContainer,
};

export const directives = {};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  states: {
    ...dataFileStates,
    ...getStates("data-file"),
  },
};
